module.exports = __webpack_public_path__ + "static/img/qrcode-xcx.b3b3189.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qrcode-xcx.png
// module id = gzjo
// module chunks = 0